import CrudManager from '@/components/admin/CrudManager';

const fields = [
    { key: 'title', label: 'Title', type: 'text' },
    { key: 'short_description', label: 'Short description', type: 'textarea', rows: 2 },
    { key: 'description', label: 'Full description', type: 'rich-text' },
    {
        key: 'icon',
        label: 'Icon (lucide slug)',
        type: 'text',
        placeholder: 'briefcase, book-open, heart-pulse...',
    },
    { key: 'image_url', label: 'Image', type: 'upload-image', prefix: 'services' },
    {
        key: 'highlights',
        label: 'Highlights',
        type: 'array',
        hint: 'Comma-separated list',
    },
    { key: 'order', label: 'Order', type: 'number' },
];

const columns = [
    { key: 'title', label: 'Title', primary: true },
    { key: 'icon', label: 'Icon' },
    { key: 'order', label: 'Order' },
];

const defaultItem = {
    title: '',
    short_description: '',
    description: '',
    icon: 'briefcase',
    image_url: '',
    highlights: [],
    order: 99,
};

export default function AdminServicesPage() {
    return (
        <CrudManager
            resource="services"
            title="Services"
            description="Manage the service domains that appear on the site."
            fields={fields}
            columns={columns}
            defaultItem={defaultItem}
            searchKeys={['title']}
        />
    );
}
